import { LocationsService } from 'data/services/locations';
import { LocationsServiceInterface } from 'domain/services/locations';
import {
  makeGetAddressViaZipCode,
  makeGetAllCitiesForSelectOptions,
} from 'main/factories/usecases/locations';

export const makeLocationsService = (): LocationsServiceInterface => {
  return new LocationsService(
    makeGetAllCitiesForSelectOptions(),
    makeGetAddressViaZipCode(),
  );
};
